import React from 'react';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Container from 'components/Container';
import { Form } from './components';
import { Footer } from 'layouts/Main/components';
import { Typography } from '@mui/material';

const PasswordResetSimple = () => {
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  return (
    <>
    <div style={{ height: 40, backgroundColor: '#377dff', padding: '10px' }}>
      <Typography
      style={{ float: 'left' }}
      variant={'subtitle2'}
      color={'white'}
    >NPS YPR</Typography>
      <a style={{ float: 'right' }} href="/online-registration-email-login" >
        <img 
        height={20}
        width={20}
        color={'white'}
        src='https://cdn-icons-png.flaticon.com/512/25/25376.png'/>
      </a>
    </div>
   
      <Container>
      <Form />
      </Container>
      <Container maxWidth={0.9} marginTop={-6}>
        <Footer />
      </Container>
    </>

  );
};

export default PasswordResetSimple;
